import { config } from "../config";

const queryParams = new URLSearchParams(location.search);
const giftUriParam = queryParams.get("giftUri");

export const giftUri = giftUriParam ? giftUriParam : config.gift.url;
